import { Form } from "@circle-react-uikit/Form";
import { Modal } from "@circle-react-uikit/ModalV2";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { useRef } from "react";

import { AddLinkFormBody } from "./AddLinkForm";
import { AddLinkHeader } from "./AddLinkHeader";
import { RemoveLinkButton } from "./RemoveLinkButton";
import { VALIDATION_SCHEMA } from "./validationSchema";

interface AddTipTapLinkModalUIKitComponentProps {
  editor: any;
  isAdminUsageContext?: boolean;
  isEmailEditor?: boolean;
}

export const AddTipTapLinkModalUIKitComponent = ({
  editor,
  isAdminUsageContext = false,
  isEmailEditor = false,
}: AddTipTapLinkModalUIKitComponentProps) => {
  const drawer = useModal();
  const isEditable = editor.isActive("link");
  const inputRef = useRef<HTMLInputElement>(null);

  const previousURL = editor.getAttributes("link")?.href;

  const handleRemoveLink = () => {
    editor.chain().focus().extendMarkRange("link").unsetLink().run();
    void drawer.hide();
  };

  const handleOnSubmit = async (
    { url }: { url: string },
    { setError }: any,
  ) => {
    try {
      await VALIDATION_SCHEMA.validate({ url });

      const isEditingLink = editor.isActive("link");
      const { from, to } = editor.state.selection;
      const hasSelection = from !== to;
      const selectedText = editor.state.doc.textBetween(from, to);
      const isOnlyWhitespace = hasSelection && selectedText.trim() === "";

      if (
        isEditingLink ||
        (hasSelection && !isOnlyWhitespace) ||
        !isEmailEditor
      ) {
        editor
          .chain()
          .focus()
          .extendMarkRange("link")
          .setLink({ href: url })
          .run();
      } else {
        editor
          .chain()
          .focus()
          .insertContent([
            {
              type: "text",
              text: url,
              marks: [{ type: "link", attrs: { href: url, target: "_blank" } }],
            },
          ])
          .run();
      }

      void drawer.hide();
    } catch (error: any) {
      setError("url", {
        type: "manual",
        message: error.message || "Invalid URL",
      });
    }
  };

  const handleClose = () => {
    void drawer.hide();
  };

  return (
    <Modal
      isOpen={drawer.visible}
      onClose={drawer.hide}
      initialFocus={inputRef}
    >
      <Modal.Overlay />
      <Modal.Content>
        <AddLinkHeader isEditable={isEditable} onClose={handleClose} />
        <Form
          onSubmit={handleOnSubmit}
          defaultValues={{ url: previousURL }}
          autoComplete="off"
        >
          <AddLinkFormBody
            inputRef={inputRef}
            submitButtonVariant={isAdminUsageContext ? "circle" : "primary"}
          >
            <RemoveLinkButton
              isEditable={isEditable}
              onClick={handleRemoveLink}
            />
          </AddLinkFormBody>
        </Form>
      </Modal.Content>
    </Modal>
  );
};
